export default {
  index: [
    {
      path: '/qysw',
      component: resolve => require(['./qyswIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/qysw/_router.js